/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ICheckoutExpressOverlayModal, ICheckoutExpressViewProps } from './checkout-express';

/**
 * Overlay modal.
 * @param param0 - Modal.
 * @param param0.modal - Modal param.
 * @returns React node.
 */
// eslint-disable-next-line @typescript-eslint/naming-convention -- public name.
const OverlayModal: React.FC<ICheckoutExpressOverlayModal> = ({ modal }) => {
    return <Node {...modal} />;
};

/**
 * Checkout express view.
 * @param param0 - Checkout express view props.
 * @param param0.checkoutExpress - Checkout express.
 * @param param0.waiting - Waiting.
 * @param param0.alert - Alert.
 * @param param0.addPaymentForm - Add payment form.
 * @param param0.overlayModal - Overlay modal.
 * @param param0.title - Module title.
 * @param param0.shouldHideExpressCheckout - ShouldHideExpressCheckout.
 * @returns React node.
 */
// eslint-disable-next-line @typescript-eslint/naming-convention -- Public name.
const CheckoutExpressView: React.FC<ICheckoutExpressViewProps> = ({
    checkoutExpress,
    waiting,
    alert,
    addPaymentForm,
    overlayModal,
    title,
    shouldHideExpressCheckout
}) =>
    shouldHideExpressCheckout ? (
        <></>
    ) : (
        <Module {...checkoutExpress}>
            {title}
            {waiting}
            {alert}
            {addPaymentForm}
            {overlayModal && <OverlayModal {...overlayModal} />}
        </Module>
    );

export default CheckoutExpressView;
